import { Component, Input, inject } from '@angular/core';
import { SiteState } from '@next/core-lib/site';
import { UserSelectors } from '@next/core-lib/user';
import { select, Store } from '@ngrx/store';
import { LetDirective } from '@ngrx/component';
import { ValueRowComponent } from '@next/core-lib/components';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'app-general-info',
    templateUrl: './general-info.component.html',
    styleUrls: ['./general-info.component.scss'],
    imports: [
        LetDirective,
        ValueRowComponent,
        TranslatePipe,
    ],
})
export class GeneralInfoComponent {
  private readonly store = inject<Store<SiteState>>(Store);

  @Input() reportForLabel = 'reportFor';
  customer$ = this.store.pipe(select(UserSelectors.selectCustomer));
}
